import { jwtDecode, JwtPayload } from "jwt-decode";
import moment, { Moment } from "moment";


const DecodeToken = (token?: string): JwtPayload | undefined => {

    if (token == null || token == "")
        return undefined;

    try {
        const result = jwtDecode<JwtPayload>(token);

        return result;
    }
    catch (error) {
        console.error("Decode JWT Token Error: ", error);
        return undefined;
    }
}

const GetExpirationDate = (token?: string): Moment | undefined => {
    const decoded = DecodeToken(token),
        result: Moment | undefined = (decoded?.exp != null && moment(decoded.exp! * 1000)) || undefined;

    return result;
}

const CheckValidToken = (token?: string, expirationTarget?: moment.Moment): boolean => {
    const decoded = DecodeToken(token);

    if (decoded == null)
        return false;

    if (expirationTarget == null)
        expirationTarget = moment();

    const validity = GetExpirationDate(token),
        result = (validity != null && validity.isAfter(expirationTarget)) || false;

    return result;
}

export const IsValidToken = (token?: string, expirationTarget?: moment.Moment): boolean => {
    const result = CheckValidToken(token, expirationTarget);

    return result;
}

export const IsExpiredToken = (token?: string, expirationTarget?: moment.Moment): boolean => {

    if (expirationTarget == null)
        expirationTarget = moment();

    const validity = GetExpirationDate(token),
        result = (token != null && token != "" && validity != null && validity.isBefore(expirationTarget)) || false;

    return result
}